import React, { Fragment, useCallback, useState } from "react";

import { IconButton, TableCell, TableRow, useTheme } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DialogComponent from "../../dialog/Dialog.component";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import CollapseStationDetailComponent from "components/collapse/CollapseStationDetail.component";
import { useTranslation } from "react-i18next";

const StationRow = (props) => {
  const {
    item,
    onEditClick = () => { },
    onDeleteClick = () => { },
    isSuperUser,
    isOperator,
  } = props
  const { t } = useTranslation()
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <Fragment>
      <TableRow>
        <TableCell padding="checkbox">
          <IconButton onClick={handleOpen}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">{item?.stationId}</TableCell>
        <TableCell align="left">{item?.address}</TableCell>
        <TableCell align="left">{item?.cluster}</TableCell>
        <TableCell align="left">{item?.alias}</TableCell>

        {(isSuperUser) && (
        // {(isSuperUser || isOperator) && (  FIXME: ONLY FOR DEMO
          <TableCell
            align="right"
            sx={{ cursor: "pointer" }}
            onClick={onEditClick}
          >
            <IconButton size="large">
              <EditTwoToneIcon
                sx={{
                  fontSize: "1.3rem",
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.secondary.main
                      : theme.palette.primary.main,
                }}
              />
            </IconButton>
          </TableCell>
        )}

        {isSuperUser && (
          <TableCell align="right" sx={{ cursor: "pointer" }}>
            <DialogComponent
              content={t('Are you sure you want to proceed with the deletion?')}
              button={
                <IconButton size="large">
                  <DeleteTwoToneIcon style={{
                    color:
                      theme.palette.mode === "dark"
                        ? theme.palette.secondary.main
                        : theme.palette.secondary.main
                  }} />
                </IconButton>
              }
              onClickYes={onDeleteClick}
            />
          </TableCell>
        )}
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0, border: 0 }} colSpan={10}>
          <CollapseStationDetailComponent
            {...props}
            open={open}
          />
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default StationRow;
